// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects'

import {
  addTranslation as addTranslationAPI
} from '../../helpers/'

import { translationAIApiResponseError, translationAIApiResponseSuccess } from './actions'
import { TranslationAIActionTypes } from './constants'

function * addTranslation ({ payload: translation }) {
  try {
    const response = yield call(addTranslationAPI, { ...translation })
    const translationItem = response.data
    yield put(translationAIApiResponseSuccess(TranslationAIActionTypes.ADD_TRANSLATION_AI, translationItem))
  } catch (error) {
    yield put(translationAIApiResponseError(TranslationAIActionTypes.ADD_TRANSLATION_AI, error))
  }
}

export function * watchAddTranslation () {
  yield takeEvery(TranslationAIActionTypes.ADD_TRANSLATION_AI, addTranslation)
}

function * translationAiSaga () {
  yield all([
    fork(watchAddTranslation)
  ])
}

export default translationAiSaga
